<template functional>
  <SocialImage
    title="Google Play"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    channel="googleplay"
    v-on="listeners"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'GooglePlayImage',
  components: {
    SocialImage,
  },
};
</script>

